// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2f1fb6b6","488":"b7388557"}[chunkId] + ".chunk.js";
};